import React from 'react';
function Heading5({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 4v16M3.5 12h8M12 4v16M17 13v3M17.005 19.384C18.5 20.5 20.5 19.5 20.501 18c0-1.5-1.001-2.5-3.5-2M17 13h3"
      />
    </svg>
  );
}

export default Heading5;
